module.exports = __webpack_public_path__ + "img/guide-img4.a9ced627.png";